module.exports = __webpack_public_path__ + "static/media/defense.ef6543f3.webp";